document.addEventListener('DOMContentLoaded', () => {
  const drawerContext = document.querySelector('#mobileNavDrawer');

  let initialRenderComplete = false;

  const observer = new MutationObserver((mutationsList) => {
    if (!initialRenderComplete) return;

    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'is-open') {
        const isOpen = drawerContext.getAttribute('is-open') !== null;
        handleDrawerChange(isOpen);
      }
    }
  });

  observer.observe(drawerContext, { attributes: true });

  function handleDrawerChange(isOpen) {
    const burger = document.querySelector('.icon-burger');

    if (isOpen) {
      burger.classList.add('open');
    } else {
      burger.classList.remove('open');
    }
  }
  window.addEventListener('load', () => {
    initialRenderComplete = true;
  });
});
